module.exports = __webpack_public_path__ + "static/index/img/baikal-904.d15f7005.jpg";